import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    products: [],
    selectedType: null, // Track selected type
};

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        setCategory: (state, action) => {
            const item = state.products.find((item) => item.id === action.payload.id)
            if (item) {
                item.id = action.payload.id;
                item.title = action.payload.title;
                item.categoryField = action.payload.categoryField;
                item.type = action.payload.type;
                item.image = action.payload.image;
                item.categoryId = action.payload.categoryId
            }
            else {
                state.products.push(action.payload);
            }
        }
    },
});

export const { setCategory, setSelectedType } = categorySlice.actions;

// Selector to get filtered categories
export const selectFilteredCategories = (state) => {
    const { categoryId, selectedType } = state.category;
    return categoryId.filter(cat =>
        (!selectedType || cat.type === selectedType) &&
        Array.isArray(cat.categoryField) &&
        cat.categoryField.length > 0
    );
};

export default categorySlice.reducer;